import {
  Config,
  Flag,
  IssueTracking,
  Settings,
  StoresManagement,
} from '@otp/icons';
import { GlobalEventType } from 'src/graphql/generated/graphql';

export const getCategoryIcon: (
  category?: GlobalEventType,
) => React.ReactNode = (category) => {
  const defaultIcon = <Flag />;
  if (!category) {
    return defaultIcon;
  }

  const categoryIconMapping = {
    [GlobalEventType.IssueAssigned]: <IssueTracking />,
    [GlobalEventType.IssueClosed]: <IssueTracking />,
    [GlobalEventType.IssueCreated]: <IssueTracking />,
    [GlobalEventType.IssueUpdated]: <IssueTracking />,
    [GlobalEventType.LoginRuleCreated]: <Settings />,
    [GlobalEventType.LoginRuleDeleted]: <Settings />,
    [GlobalEventType.LoginRuleDisabled]: <Settings />,
    [GlobalEventType.LoginRuleEnabled]: <Settings />,
    [GlobalEventType.LoginRuleUpdated]: <Settings />,
    [GlobalEventType.LoginRuleRoleCreated]: <Settings />,
    [GlobalEventType.LoginRuleRoleDeleted]: <Settings />,
    [GlobalEventType.LoginRuleRoleUpdated]: <Settings />,
    [GlobalEventType.LoginRuleUserPoolCreated]: <Settings />,
    [GlobalEventType.LoginRuleUserPoolDeleted]: <Settings />,
    [GlobalEventType.LoginRuleUserPoolUpdated]: <Settings />,
    [GlobalEventType.StoreUserAssigned]: <StoresManagement />,
    [GlobalEventType.StoreUserSetPrimary]: <StoresManagement />,
    [GlobalEventType.StoreUserUnassigned]: <StoresManagement />,
    [GlobalEventType.UserUpdated]: <Config/>,
    [GlobalEventType.WttpCompleted]: <Config />,
    [GlobalEventType.WttpExpired]: <Config />,
  };

  return category in categoryIconMapping
    ? categoryIconMapping[category as keyof typeof categoryIconMapping]
    : defaultIcon;
};
